<template>
  <pack>
    <zt-title title="插件销量统计">
      <template slot="after">
        <zt-button :type="current === 0 ? 'primary' : ''" @click="current=0">按类型查看</zt-button>
        <zt-button :type="current === 1 ? 'primary' : ''" @click="current=1">按日期查看</zt-button>
      </template>
    </zt-title>

    <CategoryTable v-show="current === 0"></CategoryTable>
    <DateTable v-show="current === 1"></DateTable>
  </pack>
</template>

<script lant="js">
import CategoryTable from './widgets/CategoryTable'
import DateTable from './widgets/DateTable'
export default  {
  name: 'DataStatisticsPlugin',
  components: { CategoryTable, DateTable },

  data: () => ({
    current: 0,
  }),

  methods: {

  },

  mounted() {

  },
}
</script>

<style lang="scss">

</style>
